<template>
  <div class="app">
    <navigation />
    <router-view />
    <vue-progress-bar />
  </div>
</template>

<script>
import Navigation from "@/components/shared/Navigation.vue";
export default {
  components: {
    navigation: Navigation
  }
};
</script>

<style>
.fade-enter-active {
  transition: opacity 0s ease-in-out;
}

.fade-leave-active {
  transition: opacity 0s ease-in-out;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

html body {
  height: 100vh;
  background-color: rgba(255, 140, 0, 0.027);
}

div.app {
  height: 100% !important;
}

::-webkit-input-placeholder {
  font-size: 10px;
  font-style: italic;
}

::-moz-placeholder {
  font-size: 10px;
  font-style: italic;
}

:-ms-input-placeholder {
  font-size: 10px;
  font-style: italic;
}
</style>
